import React from "react";
import { formatDateTime, getStatusBadgeClass, getStatusLabel } from "./utils";

export default function ContentStatusTable({ title, items, isAr, isMobile }) {
  return (
    <div className="card border-0 shadow-sm mb-4 provider-center__panel-card provider-center__table-card">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h5 className="mb-0">{title}</h5>
          <span className="badge text-bg-light">{items.length}</span>
        </div>

        {items.length === 0 ? (
          <div className="text-muted small">
            {isAr ? "لا يوجد عناصر مرسلة حتى الآن." : "No submitted items yet."}
          </div>
        ) : isMobile ? (
          <div className="provider-center__mobile-list">
            {items.map((item) => (
              <article className="provider-center__mobile-item" key={`${item.type}-${item.id}`}>
                <div className="provider-center__mobile-head">
                  <div>
                    <div className="fw-semibold">{item.titleEn || item.titleAr || `#${item.id}`}</div>
                    <div className="small text-muted">
                      {item.slug || `${item.type} #${item.id}`}
                      {item.rejectionReason ? ` · ${item.rejectionReason}` : ""}
                    </div>
                  </div>
                  <span className={`badge rounded-pill ${getStatusBadgeClass(item.approvalStatus)}`}>
                    {getStatusLabel(item.approvalStatus, isAr)}
                  </span>
                </div>
                <div className="provider-center__mobile-grid">
                  <div>
                    <div className="small text-muted">{isAr ? "الظهور" : "Visibility"}</div>
                    <div>{item.isActive ? (isAr ? "نشط" : "Active") : isAr ? "مخفي" : "Hidden"}</div>
                  </div>
                  <div>
                    <div className="small text-muted">{isAr ? "آخر تحديث" : "Last update"}</div>
                    <div>{formatDateTime(item.approvedAt || item.submittedAt)}</div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table align-middle mb-0">
              <thead>
                <tr>
                  <th>{isAr ? "العنصر" : "Item"}</th>
                  <th>{isAr ? "الحالة" : "Status"}</th>
                  <th>{isAr ? "الظهور" : "Visibility"}</th>
                  <th>{isAr ? "آخر تحديث" : "Last update"}</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={`${item.type}-${item.id}`}>
                    <td>
                      <div className="fw-semibold">{item.titleEn || item.titleAr || `#${item.id}`}</div>
                      <div className="small text-muted">
                        {item.slug || `${item.type} #${item.id}`}
                        {item.rejectionReason ? ` · ${item.rejectionReason}` : ""}
                      </div>
                    </td>
                    <td>
                      <span className={`badge rounded-pill ${getStatusBadgeClass(item.approvalStatus)}`}>
                        {getStatusLabel(item.approvalStatus, isAr)}
                      </span>
                    </td>
                    <td>{item.isActive ? (isAr ? "نشط" : "Active") : isAr ? "مخفي" : "Hidden"}</td>
                    <td>{formatDateTime(item.approvedAt || item.submittedAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
